module.exports = __webpack_public_path__ + "img/course_search_nodata.79527c5b.svg";